package org.multiplatform.kotfolio.pages.java

import androidx.compose.runtime.*
import com.varabyte.kobweb.compose.css.FontSize
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.*
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.silk.components.text.SpanText
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.Li
import org.jetbrains.compose.web.dom.Ol
import org.jetbrains.compose.web.dom.Ul
import org.multiplatform.kotfolio.layout.BlogLayout
import org.multiplatform.kotfolio.layout.BlogProperties
import org.multiplatform.kotfolio.layout.PageProperties

@Page("/java/thread")
@Composable
fun ThreadJavaPage() {
    BlogLayout(
        PageProperties(
            "Multithreading",
            ""),
        BlogProperties("Java", "Multithreading")
    ) {
        Column(
            horizontalAlignment = Alignment.Start
        ) {
            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Multithreading means various threads that run in a system. Multithreading in Java is a process of executing multiple threads simultaneously.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "A thread is single sequence of execution that can run independently in an application or program.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "A thread is a lightweight sub-process, the smallest unit of processing. Multiprocessing and multithreading, both are used to achieve multitasking.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Every java application has at least one thread - main thread.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "However, we use multithreading than multiprocessing because threads use a shared memory area. They don't allocate separate memory area so saves memory, and context-switching between the threads takes less time than process.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Java Multithreading is mostly used in games, animation, etc.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Multitasking",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 2.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "It allows your computer to run two or more programs concurrently.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "We use multitasking to utilize the CPU.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Multitasking can be achieved by 2 ways",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 2.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Ol {
                    Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                        SpanText(
                            text = "Process - based Multitasking (Multiprocessing)",
                            modifier = Modifier
                                .fontSize(FontSize.Medium)
                        )
                    }

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Each process have its own address in memory i.e. each process allocates separate memory area.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Process is heavyweight.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Cost of communication between the process is high.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Switching from one process to another require sometime for saving and loading registers, memorymaps, updating lists etc.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }

                    Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                        SpanText(
                            text = "Thread - based Multitasking (Multithreading)",
                            modifier = Modifier
                                .fontSize(FontSize.Medium)
                        )
                    }

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Threads share the same address space.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Thread is lightweight",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Cost of communication between the thread is low.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "At least one process is required for each thread. At a time only one thread is executed.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                    }
                }
            }

            SpanText(
                text = "Thread",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 2.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "A thread is lightweight sub process,  a smallest unit of processing. It is a separate path of execution. it shares the memory area of process. (A thread is an independent path of execution in a system)",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Thread types",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 2.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Ol {
                    Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                        SpanText(
                            text = "User thread",
                            modifier = Modifier
                                .fontSize(FontSize.Medium)
                        )
                    }

                    Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                        SpanText(
                            text = "Daemon thread",
                            modifier = Modifier
                                .fontSize(FontSize.Medium)
                        )
                    }
                }

                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "When we start an application, main is the first user thread created and we can create multiple user threads as well as daemon threads.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "When all the user threads are executed, JVM terminates the program.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "A thread is a single sequential flow of control within a progream.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Thread does not have its own address space but uses the memory and other resources of the process in which it executes. These may be several thread in one process.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "The Java Virtual Machine (JVM) manages these and schedules them for execution.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "The time needed to perform a context switch from one thread to another is substantially less than that required for performing such a change between processes.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Multithreading is a conceptual programming paradigm when a program (process) is divided into two or more subprograms (process), which can be implemented at the same time in parallel. For example, one subprogram can display an animation on the screen while another way builds the next animation to be displayed. This is something sililar to dividing a task into subtasks and assigning then to different people for execution independently and simultaneously.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "A thread is similar to a program that has a single folow of control. It has a begging, a body and an end, and executes command sequentially. In face, all main programs that we did can be called single threaded programs. Every program has at least one thread.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Java enables us to use multiple flows of control in developing programs. Each flow of control may be thought of as a separate tiny program know as a thread that runs in parallel to others.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "A program that contains multiple flow of control is known as multithreaded program.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Suppose in a Java program with four threads, one main thread three others. The main thread is actually the main method module, which is designed to create and start the other 3 threads, namely A, B and C. Once initiated by the main thread, the thread A, B and C run concurrently and share the resource jointly.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "The ability of a language to support multi-threads is referred to as concurrency. Since threads in Java are subprograms of a main application program and share the same memory space, in Java subprograms of a main application program and share the same memory space, they are known as lightweight threads or lightweight processes.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Thread running in parallel does not really mean they actually run at the same time. Since all the threads are running on a single processor, the flow of execution is shared between the threads. The Java interpreter handles the switching of control between the threads in such a way that it appears they are running concurrently.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Multithreading enables programmers to do multiple things at one time. They can divide a printing into the background and continue to perform some other task in the foreground. This approach would considerably improve the speed of our programs.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Threads are extensively used in Java - enabled browser such as Hot Java. These browsers can download a file to the local computer; display a web page in the window output another web page to a printer and so on.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Advantages of Multithreading",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 2.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Concurrency can be used within a process to implement multiple instances of simultaneous services.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Multithreading requires less processing overhead than multiprogramming because concurrent threads are able to share common resources more efficiently.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "A multithreaded web server is one of the example of multithreaded programming. Multithreaded web servers are able to efficiently handle multiple browser requests. They handle one request per processing thread.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Multithreading enables programmers to write very efficient programs that make maximum use of the CPU. Unlike mose other programming languages, Java provides built - in support for multithreaded programming. The Java runtime system depends on threads for many things. Java uses threads to enable the entire environment to be synchronous.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Threads are lightweight compared to processes, it takes less time and resouce to create a thread.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Threads share their parent process data and code.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Context switching between threads is usually less expensive than between processes.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Thread intercommunication is relatively easy than process communication.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "main thread",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 2.em)
                    .fontWeight(FontWeight.Bold)
            )
            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "When you start any Java program, one thread begins running immediately, which is called the main thread of that program.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Within the main thread of any Java program can crate other child threads.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Every thread has its lifetime.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "During programming you should take care that the main thread is the last thread to finish execution because it performs various shutdown actions. In face for some older JVM's if the main thread finishes before a child thread the Java run-time system many hang.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "The main thread is created automatically when your program is started.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "The main thread of Java programs is controlled through an object of Thread class.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "You can obtain a reference to Thread class object by calling the method current.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "currentThread()",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 2.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "static thread currentThread()",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "By using method, you get a reference to the thread in which this method is called.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Once you have a reference to the main thread, you can control it just like other threads created by you.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "In coming sections of this unit you will learn how to control threads.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Now let us see the program given below to obtain a reference to the main thread and the name of the main thread is set to MyFirstThread using setName (String) method of Threadclass.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

            }

            SpanText(
                text = "Life cycle Thread (Thread States)",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 2.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Ol {
                    Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                        SpanText(
                            text = "Newborn State",
                            modifier = Modifier
                                .fontSize(FontSize.Medium)
                        )
                    }

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "A newly created thread will initially be in newborn state of thread lifecycle.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "When we create a thread object, the thread is born and said to be in newborn state. The thread is not scheduled for running. At this state, we can do only one of the following with it:",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Ul {
                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Schedule it for running using start() method.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Kill it using stop() method.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "If scheduled, it moves to the Runnable state. If we attempt to use any other method at this stage, an exception will be thrown.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }

                    Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                        SpanText(
                            text = "Runnable State (start())",
                            modifier = Modifier
                                .fontSize(FontSize.Medium)
                        )
                    }

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "An active thread that is ready to run will be in Runnable State of thread lifecycle.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "When the current running finished its job or moves to Runnable/some other state then this thread will move to running state.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "If all threads have equal priority, then they are given time slots for execution in round robin fashion. i.e. first come, first server manner.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "The thread that relinquishes control join the queue at the end and again waits for its turn. This process of assigning time to threads is known as time - slicing.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "If we want a thread to relinquish control to another thread of equal priority before its turn comes, we can do so by using yield() method.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }

                    Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                        SpanText(
                            text = "Running State",
                            modifier = Modifier
                                .fontSize(FontSize.Medium)
                        )
                    }

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "An active thread is currently running will be in Running state of thread lifecycle.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "The thread in running state can be put back to Runnable State.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Running means that the processor has given its time to the thread for its execution.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "The thread run until it relinquishes control on its own or it is preempted by a higher priority thread.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "A running thread may relinquish its control in one of the following situations:",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Ul {
                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "It has been suspended using suspend() method. A suspended thread can be revived by using the resume() method. This approach is useful when we want to suspend a thread for some time due to certain reason, but do not want to kill it.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "It has been made to sleep. We can put a thread to sleep for a specified time period using the method sleep (time), where time is in milliseconds. This means that the thread is out of the queue during this time period. This means that the method i s out of the queue during this period. The thread re - enter the runnable state as soon as this time period is elapsed.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "It has been told to wait until some event occurs. This is done using the wait() method. The thread can be scheduled to run again using the notify() method.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }

                    Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                        SpanText(
                            text = "Blocked State",
                            modifier = Modifier
                                .fontSize(FontSize.Medium)
                        )
                    }

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Idle thread is currently not runnable is placed in Blocked State lifecycle.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "A thread is said to be blocked when it is prevented from entering into the runnable state and subsequently the running state.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "This happens when the thread is suspended, sleeping, or waiting in order to satisfy certain requirements.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "A blocked thread is considered not runnable but not dead and therefore fully qualified to run again.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }

                    Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                        SpanText(
                            text = "Dead State",
                            modifier = Modifier
                                .fontSize(FontSize.Medium)
                        )
                    }

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "A thread that at killed will be put in dead state of thread lifecycle. This is the last state in thread lifecycle.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "A running thread ends its life when it has completed executing its run() method. It is a natural death.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "However, we can kill it by sending the stop message to it at any state thus causing premature death to it.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "A thread can be killed as soon it is born, or while it is running, or even when it is in not runnable (blocked) condition.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "The join method allows one thread to wait for the completion of another. If it is a thread object whose is currently executing t.join(); causes the current thread to pause execution until it's thread terminates. Overloads of join allow the programmer to specify a waiting period. However, as with sleep, join dependent on the OS for timing, so you should not assume that join will wait exactly as long as you specify. Like sleep, join responds to an interrupt by exiting with an InterruptedException.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }
            }

            SpanText(
                text = "Interview Question",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 2.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ol {
                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "What is Multitasking?",
                            modifier = Modifier.fontSize(FontSize.Large)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Executing several tasks simultaneously is called multitasking.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "What is the difference between process-based and Thread-based Multitasking?",
                            modifier = Modifier.fontSize(FontSize.Large)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Process-based multitasking:- Executing several task simultaneously where each task is a separate independent process such type of multitasking is called process based Multitasking. Example:-While typing a program in the editor we can listen MP3 audio songs. At the same time we download a file from the net.   All these task are executing simultaneously and each task is a separate independent program. Hence it is process based multitasking. It is best suitable at operating system level. Thread-based multitasking:- Executing several task simultaneously where each task is a separate independent part of the same program is called Thread-based multitasking. and every independent part is called a thread. This type of multitasking is best suitable at programmatic level.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "What is Multithreading and explain its application areas?",
                            modifier = Modifier.fontSize(FontSize.Large)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Executing several thread simultaneously where each thread is a separate independent part of the same program is called multithreading. Java language provides inbuilt support for multithreading by defining a reach library, classes and interfaces like Thread, ThreadGroup, Runnable etc. The main important application area of multithreading are video games implementation, animation development, multimedia graphics etc.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "What is advantage of Multithreading?",
                            modifier = Modifier.fontSize(FontSize.Large)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "The main advantage of multithreading is reduces response time and improves performance of the system.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "When compared with C++ what is the advantage in java with respect to Multithreading?",
                            modifier = Modifier.fontSize(FontSize.Large)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Java language provides inbuilt support for multithreading by defining a reach library, classes and interfaces like Thread, ThreadGroup, Runnable etc. But in c++ there is no inbuilt support for multithreading.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "In how many ways we can define a Thread? Among extending Thread and implementing Runnable which is recommended?",
                            modifier = Modifier.fontSize(FontSize.Large)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "1) by extending Thread class or 2) by implementing Runnable interface.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Among the two ways of defining a thread implementing Runnable mechanism is always recommended. In the first approach as our Thread class already extending Thread there is no chance of extending any other. Hence, we missing the key benefit of oops(inheritance properties).",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "What is the difference between t.start() and t.run() method?",
                            modifier = Modifier.fontSize(FontSize.Large)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "In the case of t.start() method, a new thread will be created which is responsible for the execution of run() method.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "But in the case of t.run() method no new thread will be created main thread executes run() method just like a normal method call.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "If multiple threads are waiting for getting the chance for executing then which thread will get chance first decided by Thread Scheduler. It is the part of JVM and its behavior is vendor dependent and we can’t expect exact output. Whenever the situation comes to multithreading the guarantee behavior is very- very low.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "If we are not overriding run() method what will happened?",
                            modifier = Modifier.fontSize(FontSize.Large)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "If we are not overriding run() method then Thread class run() method will executed which has empty implementation and hence we will not get any output.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "Is overloading of run() method is possible?",
                            modifier = Modifier.fontSize(FontSize.Large)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Yes, we can overload run() method but Thread class start() method always invokes no-argument run() method only. The other run() method we have to call explicitly then only will be executed.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "Is it possible to override start() method?",
                            modifier = Modifier.fontSize(FontSize.Large)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Yes it is possible. But not recommended.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "If we are overriding start() method then what will happen?",
                            modifier = Modifier.fontSize(FontSize.Large)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "It we are overriding start() method then our own start() method will be executed just like a normal method call. In this case no new Thread will be created.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "Explain life cycle of a Thread?",
                            modifier = Modifier.fontSize(FontSize.Large)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Once we create a Thread object then the Thread is said to be in New/Born state once we call t.start() method now the Thread will be entered into ready/Runnable state that is Thread is ready to execute. If Thread Scheduler allocates CPU now the Thread will entered into the Running state and start execution of run() method. After completing run() method the Thread entered into Dead State.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "What is the importance of Thread class start() method?",
                            modifier = Modifier.fontSize(FontSize.Large)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Start() method present in Thread class performing all low level joining formalities for the newly created thread like registering thread with Thread Scheduler etc and then start() method invoking run() method. As the start() method is doing all low level mandatory activities, Programmer has to concentrate only on run() method to define the job. Hence, start() method is a big assistant to the programmer. Without executing Thread class start() method there is no chance of starting a new Thread.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "After starting a Thread if we trying to restart the same thread once again what will happen?",
                            modifier = Modifier.fontSize(FontSize.Large)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "After starting a Thread restarting of the same Thread once again is not allowed violation leads to Runtime Exception saying IllegalThreadStateException.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "How to get and set name of a Thread?",
                            modifier = Modifier.fontSize(FontSize.Large)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "For every Thread in java there is a name. To set and get the name of a Thread we can use the following methods. All methods are final.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "public final void setName(String name); - To set the name of a Thread",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "public final String getName(); - To get the name of a Thread.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "What is the range of Thread priority in java?",
                            modifier = Modifier.fontSize(FontSize.Large)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "The valid range of a Thread priority is 1-10. (1 is least priority and 10 is highest priority)",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "Who uses Thread priority?",
                            modifier = Modifier.fontSize(FontSize.Large)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Thread Scheduler uses priorities while allocating CPU. The Thread which is having highest priority will get chance first for execution.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "What is the default priority of the Thread?",
                            modifier = Modifier.fontSize(FontSize.Large)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "The default priority only for the main thread is 5 but for all remaining threads default priority will be inheriting from parent to child. Whatever priority parent thread has the same will be inherited to the child thread.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "Once we created a new Thread what about its priority?",
                            modifier = Modifier.fontSize(FontSize.Large)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Whatever priority parent thread has the same will be inherited to the new child thread.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "How to get and set priority of a Thread?",
                            modifier = Modifier.fontSize(FontSize.Large)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "public final int getPriority();",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "public final void setPriority(int priority);",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "If we are trying to set priority of a Thread as 100 what will happen?",
                            modifier = Modifier.fontSize(FontSize.Large)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "If we are trying to set priority of a Thread as 100 then we will not get any compile time error but at the runtime we will get Runtime exception IllegalArgumentException. Because the valid range of the Thread priority is (1-10) only.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "If two threads having same priority then which thread will get chance first for execution?",
                            modifier = Modifier.fontSize(FontSize.Large)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "If two threads having same priority then which thread will get the chance first for execution decided by Thread Scheduler. It is the part of JVM and its behavior is vendor dependent and we can’t expect exact output.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "If two threads having different priority then which thread will get chance first for execution?",
                            modifier = Modifier.fontSize(FontSize.Large)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "If two threads having different priority then the Thread which is having highest priority will get chance first for execution.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "How we can prevent a thread from execution?",
                            modifier = Modifier.fontSize(FontSize.Large)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "yield(), join(), sleep()",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "What is yield() method? Explain its purpose?",
                            modifier = Modifier.fontSize(FontSize.Large)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "yield() method causes the current executing thread to pause execution and give the chance for waiting thread are same priority. If there is no waiting thread or all the remaining waiting thread have low priority then the same thread will get chance once again for execution. The Thread which is yielded when it will get chance once again for execution depends upon mercy of Thread scheduler. public static native void yield();",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "What is purpose of join() method?",
                            modifier = Modifier.fontSize(FontSize.Large)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "If a Thread wants to wait until some other Thread completion then we should go for join() method. Example: if a Thread t1 execute t2.join() ; then t1 will entered into waiting state until t2 Thread completion.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "Is join() method is overloaded?",
                            modifier = Modifier.fontSize(FontSize.Large)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Yes join() method is overloaded method.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "public final void join() throws InterruptedException: By using this method thread will wait up to another thread completion.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "public final void join(long ms) throws InterruptedException: By using this method thread will wail upto sometime what we are passing as a argument in millisecond.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "public final void join(long ms, int ns) throws InterruptedException: By using this method thread will wait up to sometime what we are passing as a argument in millisecond and nanosecond.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "What is the purpose of sleep() method?",
                            modifier = Modifier.fontSize(FontSize.Large)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "If a Thread don’t want to perform any operation for a particular amount of time then we should go for sleep() method. Whenever we are using sleep() method compulsory we should handle InterruptedException either by using try-catch or by using throws keyword otherwise we will get compile time error.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "What is synchronized keyword? Explain its advantages and disadvantages.",
                            modifier = Modifier.fontSize(FontSize.Large)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Synchronized keyword is applicable for method and blocks only. We can’t use for variables and classes.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "If a method declared as a synchronized then at a time only one Thread is allow to execute that method on the given object.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "The main advantages of synchronized keyword are, we can prevent data inconsistency problems and we can provide Threadsafty.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "But the main limitation of synchronized keyword is it increases waiting time of Threads and effect performance of the system. Hence if there is no specific requirement it is not recommended to use synchronized keyword.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "Where we can use synchronized keyword?",
                            modifier = Modifier.fontSize(FontSize.Large)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Synchronization concept is applicable whenever multiple Threads are operating on the same object simultaneously. But whenever multiple Threads are operating on different objects then there is no impact of synchronization.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }


            }
        }
    }
}